import { Head, Link } from '@inertiajs/react'
import BackstageNav from '@/components/backstage/BackstageNav'

type Props = {
  stats: {
    leads_count: number
    leads_this_week: number
  }
}

export default function BackstageDashboard({ stats }: Props) {
  return (
    <>
      <Head title="Backstage" />

      <div className="min-h-screen bg-gray-50 font-body">
        <BackstageNav current="dashboard" />

        <div className="max-w-4xl mx-auto px-6 py-12">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">Vue d'ensemble</h1>

          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="rounded-xl bg-white border border-gray-200 p-6">
              <div className="text-sm text-gray-500 mb-1">Leads total</div>
              <div className="text-3xl font-bold text-gray-900">{stats.leads_count}</div>
            </div>
            <div className="rounded-xl bg-white border border-gray-200 p-6">
              <div className="text-sm text-gray-500 mb-1">Cette semaine</div>
              <div className="text-3xl font-bold text-gray-900">{stats.leads_this_week}</div>
            </div>
          </div>

          <nav className="space-y-2">
            <Link
              href="/backstage/leads"
              className="block rounded-xl bg-white border border-gray-200 p-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-gray-900">Leads</div>
                  <div className="text-sm text-gray-500">{stats.leads_count} inscrits</div>
                </div>
                <span className="text-gray-400">→</span>
              </div>
            </Link>
          </nav>
        </div>
      </div>
    </>
  )
}
